<template>
  <div id="app" :class="classNames">
    <header id="top-header" v-on:click="topAnim()">
      <main-logo />
    </header>
    <router-view></router-view>
    <footer id="bottom-footer">
      <div class="inner" v-html="footer" @click="toggleContactPane" title="Contact Neil"></div>
      <div class="reload" @click="reload">
        <i class="icon-chevron-up"></i>
      </div>
    </footer>
    <aside id="vector-pane">
      <top-icons />
    </aside>
    <aside id="contact-pane" class="fixed-pane">
      <contact :active="showContactPane" />
    </aside>
    <cookie-compliance />
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import Contact from "./components/Contact";
import CookieCompliance from "./components/CookieCompliance";
import TopIcons from "./components/TopIcons";
import MainLogo from "./components/MainLogo";
import {
  pageHeight,
  winWidth,
  winHeight,
  isDarkMode,
  addBodyClass,
  removeBodyClass,
  hasBodyClass,
  swapBodyClass
} from "./lib/utils";

export default {
  name: "app",
  components: {
    TopIcons,
    MainLogo,
    Contact,
    CookieCompliance
  },
  data: function() {
    return {
      extraClasses: ["bg-1"],
      logoClass: "simple",
      logoAnim: null,
      ts: 0,
      title: "Multifaceted Web Services",
      slogan: "Building applications for a connected world",
      items: [],
      winWidth: 0,
      winHeight: 0,
      pageHeight: 0,
      halfY: 0,
      stopY: 0,
      scrolling: false,
      showContactPane: false,
      displayMode: "light",
      mayStore: true,
      footer: ""
    };
  },
  created: function() {
    if (typeof window.location.pathname === "string") {
      const { pathname } = window.location;
      if (pathname === "/index.php") {
        const title = document.querySelector("title").textContent;
        history.replaceState({ page: "home" }, title, "/");
      }
    }
    this.loadContent();
    this.updatePageTitle();
    this.detectScheme();
    setTimeout(() => {
      if (SVGMorpheus) {
        this.logoAnim = new SVGMorpheus("#main-logo");
        setTimeout(() => {
          this.logoAnim.to(
            "logo_full",
            { duration: 3000, easing: "linear", rotation: "none" },
            null
          );
          this.logoClass = "full";
          if (this.winWidth < 750) {
            setTimeout(() => {
              this.logoAnim.to(
                "logo_simple",
                { duration: 2000, easing: "linear", rotation: "none" },
                null
              );
              this.logoClass = "simple";
            }, 6000);
          }
        }, 2000);
      }
    }, 1000);
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("keydown", e => {
      switch (e.which) {
        case 27:
          this.$emit("escape", true);
          removeBodyClass("show-contact-pane");
          this.showContactPane = false;
          break;
      }
    });
  },
  watch: {
    title(cv, pv) {
      if (cv !== pv) {
        this.updatePageTitle();
      }
    },
    showContactPane(cv, pv) {
      if (cv !== pv) {
        if (cv === true) {
          addBodyClass("show-contact-pane");
        } else {
          removeBodyClass("show-contact-pane");
        }
      }
    }
  },
  computed: {
    ratio() {
      return this.winWidth / this.winHeight;
    },
    classNames() {
      let cls = this.extraClasses.filter(c => c !== "clone");
      if (this.ratio > 1.6) {
        cls.push("ultra-wide");
      }
      if (this.ratio > 1.15) {
        cls.push("landscape");
      } else if (this.ratio > 0.85) {
        cls.push("square");
      }
      if (this.ratio <= 0.85) {
        cls.push("portrait");
      }
      if (this.ratio <= 0.625) {
        cls.push("ultra-tall");
      }
      return cls;
    }
  },
  methods: {
    loadContent(reload) {
      let data = this.$ls.get("all-panes", null);
      if (reload !== true && data instanceof Object && data.valid) {
        this.updateSiteData(data);
      } else {
        const backUrl = "/static/data/page-sections.json";
        this.$http.get(backUrl).then(
          response => {
            if (response.data) {
              if (typeof response.data === "object") {
                if (response.data instanceof Object) {
                  if (response.data.valid) {
                    if (this.mayStore) {
                      this.$ls.set(
                        "all-panes",
                        response.data,
                        24 * 60 * 60 * 1000
                      );
                    }
                    this.updateSiteData(response.data);
                    const { ts } = response.data;
                    const currTs = new Date().getTime() / 1000;
                    const secsAgo = currTs - ts;
                    if (secsAgo < 24 * 60 * 60) {
                      this.updateJsonSource();
                    }
                  }
                }
              }
            }
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    updateSiteData(data) {
      if (data.ts) {
        this.ts = data.ts;
      }
      if (data.title) {
        this.title = data.title;
        if (data.slogan) {
          this.slogan = data.slogan;
        }
      }
      if (data.footer) {
        this.footer = data.footer;
      }
      if (data.items instanceof Array) {
        this.items = data.items;
      }
    },
    updatePageTitle() {
      const t = document.getElementsByTagName("title");
      if (t.length > 0) {
        t[0].innerHTML = this.title;
      }
    },
    updateJsonSource() {
      this.$http
        .get("/backend-fetch.php")
        .then(data => {
          if (data.valid) {
            console.log("updated");
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    reload() {
      this.loadContent(true);
    },
    topAnim() {
      if (SVGMorpheus) {
        if (this.logoAnim) {
          this.logoAnim.to(
            "logo_simple",
            { duration: 2000, easing: "linear", rotation: "none" },
            null
          );
          this.logoClass = "simple";
          setTimeout(() => {
            this.logoAnim.to(
              "logo_full",
              { duration: 3000, easing: "linear", rotation: "none" },
              null
            );
            this.logoClass = "full";
            if (this.winWidth < 750) {
              setTimeout(() => {
                this.logoAnim.to(
                  "logo_simple",
                  { duration: 2000, easing: "linear", rotation: "none" },
                  null
                );
                this.logoClass = "simple";
              }, 4000);
            }
          }, 5000);
        }
      }
    },
    scrollTo(selector, offset, ms) {
      if (!this.scrolling) {
        this.scrolling = true;
        VueScrollTo.scrollTo(selector, ms, {
          container: "body",
          offset: offset,
          easing: "ease-in",
          cancelable: false
        });
      }
      setTimeout(() => {
        this.scrolling = false;
      }, 1200);
    },
    handleResize(init) {
      this.pageHeight = pageHeight();
      this.winHeight = window.innerHeight;
      this.winWidth = winWidth();
      this.stopY = this.winHeight / 64;
      this.halfY = this.winHeight / 2;
      if (init !== true) {
        if (this.winWidth < 750 && this.logoClass !== "simple") {
          this.logoAnim.to(
            "logo_simple",
            { duration: 2000, easing: "linear", rotation: "none" },
            null
          );
          this.logoClass = "simple";
        } else if (this.winWidth >= 750 && this.logoClass !== "full") {
          this.logoAnim.to(
            "logo_full",
            { duration: 2000, easing: "linear", rotation: "none" },
            null
          );
          this.logoClass = "full";
        }
      }
      this.$emit("resized");
    },
    toggleDark() {
      this.displayMode = this.displayMode === "dark" ? "light" : "dark";
      this.switchScheme(true);
    },
    detectScheme() {
      const storedVal = this.$ls.get("scheme");

      switch (storedVal) {
        case "dark":
        case "light":
          this.displayMode = storedVal;
          break;
        default:
          this.displayMode = isDarkMode() ? "dark" : "light";
          break;
      }
      if (this.displayMode === "dark") {
        this.switchScheme();
      }
    },
    switchScheme(store) {
      switch (this.displayMode) {
        case "dark":
          addBodyClass("dark");
          removeBodyClass("light");
          break;
        default:
          addBodyClass("light");
          removeBodyClass("dark");
          break;
      }
      if (store === true) {
        this.$ls.set("scheme", this.displayMode, 60 * 60 * 1000);
      }
    },
    toggleContactPane(mode) {
      let skip = false;
      if (mode instanceof Object) {
        if (mode.target) {
          if (mode.target.tagName) {
            switch (mode.target.tagName.toLowerCase()) {
              case "a":
                skip = true;
                break;
            }
          }
        }
      }
      console.log(skip, mode);
      if (!skip) {
        switch (mode) {
          case "show":
            this.showContactPane = true;
            break;
          case "hide":
            this.showContactPane = false;
            break;
          default:
            this.showContactPane = !this.showContactPane;
            break;
        }
      }
    }
  }
};
</script>

<style>
html,
body {
  position: relative;
  margin: 0;
  padding: 0;
}

html {
  font-size: 16px;
}

@media screen and (min-width: 750px) {
  html {
    font-size: 17px;
  }
}

@media screen and (min-width: 960px) {
  html {
    font-size: 18px;
  }
}

@media screen and (min-width: 1120px) {
  html {
    font-size: 19px;
  }
}

@media screen and (min-width: 1200px) {
  html {
    font-size: 20px;
  }
}

@media screen and (min-width: 1280px) {
  html {
    font-size: 21px;
  }
}

@media screen and (min-width: 1440px) {
  html {
    font-size: 22px;
  }
}

@media screen and (min-width: 1520px) {
  html {
    font-size: 23px;
  }
}

@media screen and (min-width: 1600px) {
  html {
    font-size: 24px;
  }
}

@media screen and (min-width: 1700px) {
  html {
    font-size: 25px;
  }
}

@media screen and (min-width: 1800px) {
  html {
    font-size: 26px;
  }
}

@media screen and (min-width: 1900px) {
  html {
    font-size: 28px;
  }
}

#app {
  font-family: "Sintony", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  margin: 0;
  padding: 0;
  max-width: 100%;
  position: relative;
}

#app h2 {
  font-family: "Snippet", Helvetica, Arial, sans-serif;
}

#side-nav ul,
#side-nav li,
#app ul.panes,
#app ul.panes > li.pane {
  list-style-type: none;
}

#side-nav ul,
#side-nav li,
#app ul.panes {
  margin: 0;
}

#app ul.panes > li.pane {
  margin: 3em 0 15vh 0;
}

#app ul.panes > li.pane:last-child {
  min-height: 60vh;
  margin-bottom: 5vh;
}

#app.landscape ul.panes > li.pane:last-child {
  min-height: 55vh;
}

#app.ultra-wide ul.panes > li.pane:last-child {
  min-height: 50vh;
}

@media screen and (min-height: 750px) {
  #app ul.panes > li.pane:last-child {
    min-height: 70vh;
    margin-bottom: 5vh;
  }

  #app.landscape ul.panes > li.pane:last-child {
    min-height: 65vh;
  }

  #app.ultra-wide ul.panes > li.pane:last-child {
    min-height: 60vh;
  }
}

#side-nav ul {
  padding: 1em 5%;
}

#app ul > li.pane {
  position: relative;
  min-height: 100vh;
  text-align: left;
  padding: 1em 0;
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
}

#app ul > li.pane > article {
  width: 92%;
  position: relative;
  padding: 1em 4% 2.5em 4%;
}

#app ul > li.pane > article > h2 {
  margin-top: 0.5em;
}

ul > li.pane > article a,
ul > li.pane > article {
  color: black;
}

.dark #app .fixed-pane,
.dark ul > li.pane > article a,
.dark ul > li.pane > article {
  color: white;
}

#bottom-footer {
  position: relative;
  padding: 2em 0 0 0;
  margin: 0 auto;
  width: 100%;
  transition: opacity 1s ease-in;
  opacity: 0;
  background: linear-gradient(
    0.5turn,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  z-index: 111;
  pointer-events: none;
}

body.loaded #bottom-footer {
  opacity: 1;
}

#bottom-footer .reload {
  position: absolute;
  bottom: 0.75em;
  left: 2%;
  opacity: 0;
  cursor: pointer;
}

#bottom-footer .reload:hover {
  opacity: 1;
}

.dark #bottom-footer {
  color: white;
  background: linear-gradient(0.5turn, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
}

#bottom-footer .inner {
  max-width: 60em;
  margin: 0 auto;
  padding: 1em 0;
  font-size: 0.8em;
}

#bottom-footer .reload,
#bottom-footer .inner p,
#bottom-footer .inner a {
  pointer-events: all;
}

#bottom-footer .inner p {
  text-align: center;
  width: 100%;
  padding: 0.5em 0;
  margin-block-start: 0;
  margin-block-end: 0;
  cursor: pointer;
}

#bottom-footer .inner .smallprint {
  font-size: 0.75em;
}

#bottom-footer .inner a,
#bottom-footer .inner i,
#bottom-footer .inner span {
  display: inline-block;
}

#bottom-footer .inner address a {
  color: black;
}

#bottom-footer .inner address a > i {
  position: relative;
  font-size: 2em;
  margin-right: 0.75em;
  top: 0.1875em;
}

#app a i {
  text-decoration: none;
}

#app .close {
  cursor: pointer;
  user-select: none;
  font-size: 1.25em;
  transition: transform 0.25s ease-in-out;
}

#app .close:hover {
  transform: scale(1.3333);
}

.dark #app .close,
.dark #app .fixed-pane p,
.dark #bottom-footer .inner address a,
.dark #app ul > li.active > article a,
.dark #app ul > li.active > article {
  color: white;
}

.dark #app .fixed-pane form input.button,
.dark #app .fixed-pane form select,
.dark #app .fixed-pane form .textfield {
  color: white;
  background-color: black;
}

.dark #app .fixed-pane form input.button,
.dark #app .fixed-pane form select,
.dark #app .fixed-pane form .textfield,
.dark #faqs .sub-section,
.dark #experience article .body ul > li {
  border-color: white;
}

ul > li.active > article a {
  display: inline-block;
  font-style: italic;
  padding: 0 0.125em;
  text-decoration: none;
}

ul > li.active > article a:hover {
  text-decoration: underline;
}

#side-nav li {
  margin: 0;
  padding: 0 0 0.25em 0;
  text-align: right;
}

article .highlight i,
article .highlight span,
#app button i,
#app button span,
#side-nav li span,
#side-nav li i {
  display: inline-block;
}

#side-nav li span.label {
  font-size: 0.75em;
}

#app article .highlight span.text,
#app button span.text,
#side-nav li span {
  margin-left: 0.5em;
}

#side-nav li:hover i.contact::before {
  content: "\e903";
}

#app #main-content {
  position: relative;
  z-index: 3;
  margin-top: 5em;
}

@media screen and (max-width: 750px) and (max-height: 1000px) {
  #app #main-content article {
    font-size: 1.125em;
  }
}

@media screen and (max-width: 450px) and (max-height: 750px) {
  #app #main-content article {
    font-size: 1.25em;
  }
}

@media screen and (max-width: 400px) and (max-height: 750px) {
  #app #main-content article {
    font-size: 1.375em;
  }
}

#side-nav {
  padding: 1em 0;
  text-align: left;
  background-color: rgba(255, 255, 255, 0.5);
  top: 0;
  height: 2em;
  z-index: 20;
  width: 100%;
  transition: height 0.5s ease-in, background-color 0.5s ease-in;
}

/* .scrolled-down #side-nav {
  height: 1.5em;
} */

#top-header {
  position: fixed;
  top: 0;
  left: 2.5em;
  right: 2.5em;
  height: 3em;
  z-index: 100;
  transition: all 1s ease-in-out;
}

#top-header svg {
  margin-top: 1vh;
  max-width: 90%;
  max-height: 100%;
  transition: all 1s ease-in-out;
  cursor: pointer;
}

#top-header svg:hover {
  transform: scale(1.05) skew(-5deg);
}

.show-menu #top-header {
  pointer-events: none;
}

.scrolled-down #top-header svg {
  margin-top: 0.5em;
  max-width: 82%;
}

.scrolled-down #top-header {
  padding-bottom: 0.125em;
}

#side-nav ul {
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  margin-top: 2em;
  transition: opacity 0.5s ease-in;
  padding-inline-start: 1em;
  margin-block-start: 0;
  margin-block-end: 0;
}

.menu-expanded #side-nav ul {
  opacity: 1;
  pointer-events: all;
}

.menu-expanded #side-nav {
  height: 22em;
  background-color: rgba(255, 255, 255, 0.75);
}

.dark #app .fixed-pane,
.dark .menu-expanded #side-nav {
  background-color: rgba(0, 0, 0, 0.75);
}

.dark #cookie-overlay {
  border-top: solid 0.25em rgba(255, 255, 255, 0.25);
}

.dark #side-nav li.toggle-dark i.icon {
  color: blue;
}

#scroll-down {
  position: fixed;
  bottom: 3vh;
  left: 25vw;
  margin-left: -0.5em;
  width: 50vw;
  font-size: 1em;
  min-height: 2em;
  z-index: 110;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

#scroll-down:before {
  position: absolute;
  bottom: 0;
  left: 50%;
}

@media screen and (min-height: 400px) {
  #scroll-down {
    font-size: 1.5em;
  }
}

@media screen and (min-height: 600px) {
  #scroll-down {
    font-size: 2em;
  }
}

@media screen and (min-width: 1250px) {
  @media screen and (min-height: 750px) {
    #scroll-down {
      font-size: 2.5em;
    }
  }

  @media screen and (min-height: 900px) {
    #scroll-down {
      font-size: 3em;
    }
  }
}

.show-down .scrolling #scroll-down {
  opacity: 0.25;
}

.show-down .hide-arrow #scroll-down {
  opacity: 0;
}

.show-down .hide-arrow #scroll-down:hover,
.show-down #scroll-down {
  opacity: 0.5;
  cursor: pointer;
}

@media screen and (max-width: 449px) {
  .menu-expanded #side-nav li {
    font-size: 1.2em;
    line-height: 1em;
  }
  #app .menu-expanded #side-nav {
    height: 26em;
  }
  @media (max-height: 400px) {
    #app .menu-expanded #side-nav {
      height: 16.5em;
    }
  }
}

@media screen and (min-width: 450px) and (max-width: 749px) {
  .menu-expanded #side-nav li {
    font-size: 1.333em;
  }
  #app .menu-expanded #side-nav {
    height: 26em;
  }
  @media (max-height: 400px) {
    #app .menu-expanded #side-nav {
      height: 15em;
    }
  }
}

#vector-pane {
  width: 3em;
  padding: 2vw 2%;
  z-index: 22;
  transition: all 0.5s ease-in;
  user-select: none;
}

#vector-pane,
#top-header {
  pointer-events: none;
}

.show-menu #vector-pane,
.show-menu #top-header {
  pointer-events: all;
}

.show-menu #vector-pane {
  top: 0;
  left: -0.5em;
  width: 7.5em;
  height: 7.5em;
}

.show-menu #top-header {
  left: 5em;
  right: 2.5em;
}

.panes-container li.pane > article {
  background-color: rgba(255, 255, 255, 0.8);
}

.dark .panes-container li.pane > article {
  background-color: rgba(0, 0, 0, 0.8);
}

.dark #app #top-header,
.dark #app #side-nav {
  filter: invert(100%);
}

#app.bg-1 #side-nav {
  background-color: rgba(204, 204, 255, 0.6);
}

#app.bg-2 #side-nav {
  background-color: #ffff99;
  background-color: rgba(255, 255, 153, 0.6);
}

#app.bg-3 #side-nav {
  background-color: #ccffcc;
  background-color: rgba(204, 255, 204, 0.6);
}

#app.bg-4 #side-nav {
  background-color: #ff99ff;
  background-color: rgba(255, 153, 255, 0.6);
}

#app.bg-5 .#side-nav {
  background-color: #ccccff;
  background-color: rgba(204, 204, 255, 0.6);
}

#app.bg-6 #side-nav {
  background-color: #99ffff;
  background-color: rgba(153, 255, 255, 0.6);
}

#vector-pane svg g > path {
  fill: #336699;
  transition: fill 1.5s ease-in-out;
}

#app.bg-2 #vector-pane svg g > path {
  fill: #669933;
}

#app.bg-3 #vector-pane svg g > path {
  fill: #663399;
}

#app.bg-4 #vector-pane svg g > path {
  fill: #338888;
}

#app.bg-5 #vector-pane svg g > path {
  fill: #883388;
}

#app.bg-6 #vector-pane svg g > path {
  fill: #888833;
}

#background-picture,
#side-nav,
#vector-pane {
  position: fixed;
  left: 0;
}

#background-picture {
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

#loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  animation: fadein 1s 1;
  background-image: url(/static/images/loading-wheel.svg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80vw;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  opacity: 1;
}

body.loaded #loader {
  opacity: 0;
}

body {
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

body.loaded {
  max-height: none;
  overflow: auto;
  overflow-x: hidden;
}

#background-picture img {
  position: absolute;
  top: 0;
  left: 0;
}

#main-logo > g {
  transform: translate(-45px, -455px);
  transition: margin-left 1s ease-in-out;
}

#main-logo.simple {
  margin-left: 15%;
}

#background-picture.current img.prev-bg {
  opacity: 0;
}

#main-logo path {
  fill: #7777aa;
  transition: fill 1s ease-in-out;
}

.bg-2 #main-logo path {
  fill: #66aa66;
}

.bg-3 #main-logo path {
  fill: #aa6666;
}

.bg-4 #main-logo path {
  fill: #66aaaa;
}

.bg-5 #main-logo path {
  fill: #aa66aa;
}

.bg-6 #main-logo path {
  fill: #aaaa66;
}

#background-picture .curr-bg,
#background-picture .switching img.prev-bg {
  opacity: 1;
}

#background-picture.switching img.prev-bg {
  animation: fadeout 2s linear 1;
}

#background-picture.switching img.curr-bg {
  opacity: 0;
  animation: fadein 2s linear 1;
}

#vector-pane {
  top: 0;
  font-size: 1em;
  height: 2.5em;
}

#vector-pane svg {
  max-height: 100%;
}

#side-nav li {
  font-size: 0.9em;
  padding: 0 0 1em 0;
  cursor: pointer;
  transform: scale(1) translate(0, 0);
  transition: transform 0.333s ease-in-out;
}

@media screen and (max-height: 400px) and (max-width: 749px) {
  #side-nav ul {
    margin-top: 4em;
    margin-left: 20%;
  }

  #side-nav li {
    width: 40%;
    float: left;
    padding-left: 10%;
  }
}

#side-nav li.active,
#side-nav li:hover {
  transform: scale(1.2) translate(-7.5%, 0);
}

#app ul.panes,
#app figure {
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
  -webkit-padding-start: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  margin: 0;
  padding: 0;
}

#background-picture {
  pointer-events: none;
  user-select: none;
}

#app figure#background-picture img {
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
  object-fit: cover;
  transition: transform 1s ease-in-out;
}

#app .flip-x figure#background-picture img.curr-bg {
  transform: scaleX(-1);
}

#app button.menu-toggle {
  position: absolute;
  top: 0.25em;
  right: 2.5%;
  background: none;
  border: none;
  width: 95%;
  min-height: 2em;
  outline: none;
  cursor: pointer;
  font-size: 2.25em;
  z-index: 200;
}

button.menu-toggle:before {
  position: absolute;
  top: 0;
  right: 0;
}

.body > blockquote {
  max-width: 20em;
  padding: 0 0 1.25em 1.25em;
  margin: 0 0 1.25em 1.25em;
  float: right;
}

.body > blockquote p:first-child {
  padding-top: 0;
  margin-top: 0;
}

.fixed-pane {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.75);
}

#cookie-overlay {
  bottom: -20em;
  left: 0;
  right: 0;
  z-index: 150;
  margin: 0 auto;
  padding: 0.5em 2.5%;
  transition: bottom 0.75s ease-in-out;
  pointer-events: none;
  border-top: solid 0.25em rgba(0, 0, 0, 0.25);
}

#cookie-overlay .inner {
  position: relative;
  margin: 0 auto;
  font-size: 0.75em;
  max-width: 50em;
}

#cookie-overlay.show {
  bottom: 0;
  pointer-events: all;
}

#contact-pane {
  right: -100vw;
  width: 100vw;
  top: 2.5em;
  max-width: 40em;
  transition: right 1s ease-in-out;
  min-height: 60vh;
  z-index: 200;
  pointer-events: none;
}

#contact-pane .close {
  position: absolute;
  top: 0.375em;
  right: 0.375em;
  cursor: pointer;
  z-index: 150;
}

#contact-pane form {
  display: flex;
  flex-flow: column;
}

#contact-pane form,
#contact-pane .response {
  width: 92%;
  padding: 1.25em 4% 0.75em 4%;
  position: relative;
}

label.small {
  font-size: 0.75em;
}

#contact-pane form label {
  text-align: left;
  clear: both;
  margin: 0.25em 0 0 0;
}

#contact-pane form select,
#contact-pane form .textfield {
  min-width: 98%;
  padding: 0.125em 1%;
  margin: 0 0 1em 0;
  border: solid 1px black;
}

#contact-pane form .textfield {
  width: 98%;
}

.show-contact-pane #contact-pane {
  right: 0;
  pointer-events: all;
}

#app #main-content article ul.highlight {
  width: 100%;
  text-align: center;
  font-size: 1.25em;
  margin: 1em auto;
}

#app ul.plain {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
}

#app ul.plain,
#app ul.plain li {
  list-style: none;
  padding: 0;
}

#app ul.plain li {
  margin: 0;
}

#app ul.horizontal {
  display: flex;
  flex-flow: row nowrap;
}

#app ul.highlight.horizontal li a {
  display: inline-block;
  margin: 0 1em;
}

#app #technologies ul.highlight > li::before {
  content: "";
}

#app article li h4,
#app article li p,
#services .body > ul,
#technologies .body > ul,
#app #experience > article > ul {
  margin-block-start: 0;
  margin-block-end: 0;
}

#services .body > ul,
#services .body > ul > li,
#technologies .body > ul,
#technologies .body > ul > li,
#experience article .body > ul > li,
#experience .body > ul {
  list-style: none;
}

#services .body > ul,
#technologies .body > ul {
  padding-inline-start: 0;
}

#services .body > ul > li,
#technologies .body > ul > li {
  padding-left: 1.5em;
}

#services .body > ul > li::before,
#technologies .body > ul > li::before,
#experience article .body ul > li::before {
  position: absolute;
  left: 0;
  font-family: icomoon;
}

#technologies .body > ul > li::before {
  content: "\e90b";
  top: 0;
}

#services .body > ul > li::before {
  content: "\e906";
  top: 0;
}

#experience article .body ul > li::before {
  content: "\e90d";
  top: 0.5625em;
}

#services .body > ul > li,
#technologies .body > ul > li,
#experience article .body ul > li {
  position: relative;
}

#services .body > ul > li,
#technologies .body > ul > li {
  margin-bottom: 0.5em;
}

#experience article .body ul > li {
  padding-inline-start: 0;
  padding: 0.5em 0 0.75em 0;
  margin: 0.75em 0 0.5em 0;
  border-bottom: dashed 1px black;
}

#experience article .body ul > li h4 {
  margin: 0 0 0.125em 0;
  padding: 0 0 0.25em 1.25em;
}

#experience article .body ul > li:last-child {
  border-bottom: none;
}

#faqs article .sub-section {
  padding: 0.5em 0 1em 0;
  margin: 0.5em;
  border-top: dashed 1px black;
  width: 100%;
}

#faqs article .sub-section > h3 {
  margin: 0.5em 0 0.125em 0;
  padding: 0.25em 0;
  margin-block-end: 0;
  padding-bottom: 0;
  padding-inline-start: 0;
  padding-inline-end: 0;
}

#faqs article .sub-section .sub-body > p:first-child {
  padding-top: 0;
  margin-top: 0.5em;
}

@media screen and (min-width: 450px) {
  .show-menu #vector-pane {
    width: 8em;
  }
  #side-nav ul {
    margin-top: 3em;
  }
  .menu-expanded #side-nav {
    height: 25em;
  }
  #app button.menu-toggle {
    font-size: 2.5em;
  }
}

@media screen and (min-width: 750px) {
  #vector-pane {
    height: 16vw;
    max-height: 20vh;
    width: 16%;
    padding: 2vw 2%;
  }

  #main-logo.simple {
    margin-left: 12%;
  }

  #app ul > li.pane {
    padding: 1em 2.5%;
    width: 90%;
  }

  #app .panes-container {
    margin-left: 20%;
    width: 80%;
    margin-top: 0;
  }

  #app #side-nav {
    top: 18vw;
    pointer-events: all;
    z-index: 30;
    width: 20%;
    min-width: 20%;
    max-width: 20%;
    height: auto;
    padding: 0.125em 0;
  }

  @media (max-height: 750px) {
    body #app #side-nav li {
      padding: 0 0 0.75em 0;
    }
  }

  @media (max-height: 600px) {
    body #app #side-nav li {
      padding: 0 0 0.5em 0;
    }

    body #app #side-nav {
      top: 8vw;
    }

    body #side-nav ul {
      padding-top: 0.25em;
    }

    body #side-nav li {
      padding-bottom: 0.5em;
    }

    body #app.scrolled-down #side-nav {
      top: 4em;
    }

    body #app #vector-pane {
      top: -0.75em;
      height: 7.5vw;
      z-index: 300;
    }

    body #app.scrolled-down #vector-pane {
      height: 5vw;
    }
  }

  .show-contact-pane #contact-pane {
    right: 2.5%;
  }

  @media (max-height: 525px) {
    body #app.scrolled-down #side-nav {
      top: 1.625em;
    }
  }

  @media (max-height: 450px) {
    #app #side-nav {
      top: 35vh;
    }
  }

  @media (min-height: 451px) and (max-height: 600px) {
    #app #side-nav {
      top: 30vh;
    }
  }

  @media (min-height: 601px) and (max-height: 720px) {
    #app #side-nav {
      top: 25vh;
    }
  }

  #side-nav li {
    text-align: left;
  }

  #side-nav li.active,
  #side-nav li:hover {
    transform: scale(1.2) translate(7.5%, 0);
  }

  #app .menu-toggle {
    display: none;
  }

  #vector-pane,
  #top-header {
    pointer-events: all;
  }

  #app #main-content {
    margin-top: 5em;
  }

  #side-nav ul {
    opacity: 1;
    pointer-events: all;
    margin-top: 0;
  }

  #top-header {
    left: 0;
    padding-left: 12.5%;
    right: 0;
    height: 4em;
  }

  .scrolled-down #top-header {
    background-color: rgba(255, 255, 255, 0.6667);
    height: 1.5em;
    padding-left: 0;
  }

  .scrolled-down #vector-pane {
    top: 0.75em;
    height: 16vw;
  }

  @media (min-height: 750px) {
    .scrolled-down #vector-pane {
      top: 1em;
      height: 18vw;
    }
  }

  .scrolled-down #top-header svg {
    margin-top: 0;
  }
}

@media screen and (min-width: 1000px) {
  #app ul > li.pane > article {
    padding: 0.5em 5% 1em 2.5%;
  }
  #top-header {
    height: 5em;
  }

  #app #main-content {
    margin-top: 6em;
  }

  .scrolled-down #top-header {
    height: 1.75em;
  }
  #side-nav li {
    font-size: 1em;
    padding: 0 0 0.8em 0;
  }
}

@media screen and (min-width: 750px) and (min-height: 500px) {
  #contact-pane {
    width: 95vw;
    top: 4em;
  }
}

@media screen and (min-width: 975px) {
  @media and (min-height: 625px) {
    #contact-pane {
      width: 90vw;
      top: 5em;
    }
  }
  #app ul > li.pane {
    width: 80%;
  }
  .show-contact-pane #contact-pane {
    right: 5%;
  }
}

@media screen and (min-width: 1125px) {
  #app ul > li.pane {
    width: 75%;
  }

  #app ul > li.pane > article {
    padding: 0.5em 6.25% 1em 2.5%;
  }

  #top-header {
    height: 5.5em;
  }
  #app #main-content {
    margin-top: 5.5em;
  }

  @media and (min-height: 675px) {
    #contact-pane {
      top: 6em;
    }
  }

  .scrolled-down #top-header {
    height: 1.875em;
  }

  .scrolled-down #vector-pane {
    top: 1.125em;
  }

  #side-nav li {
    font-size: 1.1em;
  }

  .show-contact-pane #contact-pane {
    right: 7.5%;
  }
}

@media screen and (min-width: 1250px) {
  #app ul > li.pane > article {
    padding: 0.5em 7.5% 1em 2.5%;
  }
  #top-header {
    height: 6em;
  }

  #app #main-content {
    margin-top: 6em;
  }

  .scrolled-down #top-header {
    height: 2em;
  }

  .scrolled-down #vector-pane {
    top: 1.25em;
  }
  #side-nav li {
    font-size: 1.2em;
  }
  .show-contact-pane #contact-pane {
    right: 10%;
  }
  #bottom-footer .inner {
    font-size: 0.75em;
  }
}

@media screen and (min-width: 1500px) {
  #app ul > li.pane > article {
    padding: 0.5em 8.75% 1em 2.5%;
  }
  #top-header {
    height: 7em;
  }

  #app #main-content {
    margin-top: 7em;
  }

  #side-nav li {
    font-size: 1.25em;
  }
  #bottom-footer .inner {
    font-size: 0.625em;
  }

  #app #side-nav {
    top: 27.5vh;
  }
}

@media screen and (min-width: 1750px) {
  #app ul > li.pane > article {
    padding: 0.5em 10% 1em 2.5%;
  }

  #app ul > li.pane {
    max-width: 1325px;
  }

  #top-header {
    height: 8em;
  }

  #app #main-content {
    margin-top: 8em;
  }

  .scrolled-down #top-header {
    height: 2.125em;
  }
  .scrolled-down #vector-pane {
    top: 1.375em;
  }
}

#app button {
  border: none;
  padding: 0.375em 0.5em;
  border-radius: 0.25em;
  font-size: 1em;
}

#app .fixed-pane button {
  color: white;
}

#app .fixed-pane button {
  margin: 0.25em 2em;
}

#app #contact-pane.fixed-pane button.button {
  margin: 0.25em 0;
}

#app button.agree {
  background-color: #009933;
}

#app button.button {
  background-color: #003399;
}

#app button.disagree {
  background-color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// App.vue?c037df12